export type ICoordinates = {
  lat: number;
  lng: number;
};

export const CU_COORDINATES: ICoordinates[] = [{ lat: 23.13611227322044, lng: -82.3596177815727 }]; // Havana capital coordinates

export const MX_COORDINATES: ICoordinates[] = [{ lat: 19.42847, lng: -99.12766 }]; // Mexico city coordinates

export const USA_COORDINATES: ICoordinates[] = [{ lat: 27.88354, lng: -81.55827 }];
